import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { PharmacyCard } from '@ui/checkout/pharmacy-card';
import { LazyImage } from '@ui/common/lazy-image.tsx';
import { useAtomValue, useAtom } from 'jotai/index';
import { cityAtom } from '@app/atoms/app/city.atom.ts';
import {
  checkoutAtom,
  productsAtom,
} from '../../entites/cart/use-cart-products.store.ts';
import { useStoresList } from '../../entites/store/use-stores-list.ts';
import { ProductStatusProps } from '@ui/product/product-status.tsx';
import { useNavigate, useParams } from 'react-router-dom';

export const AvailabilityPage = () => {
  const set = useNavbar();
  const navigate = useNavigate();
  const { pharmacyId } = useParams<{ pharmacyId: string }>();

  const city = useAtomValue(cityAtom);
  const cart = useAtomValue(productsAtom);
  const [checkout, setCheckout] = useAtom(checkoutAtom);
  const { rawData = [] } = useStoresList({
    selectedProductId: cart.map((i) => i.id),
    selectedCityId: city.id,
  });

  const pharmacyInfo = rawData
    .map((pharmacy) => {
      return {
        pharmacy: {
          id: pharmacy.id,
          address: pharmacy.address,
          name: `Аптека №${pharmacy.id}`,
          variant: checkout.pharmacyId === pharmacy.id ? 'select' : 'info',
          statuses: [
            { variant: 'open', children: 'Открыто с 10:00 до 00:00' },
            { variant: 'available' },
          ] as ProductStatusProps[],
        },
        available: pharmacy,
      } as const;
    })
    .find((item) => item.pharmacy.id === Number(pharmacyId));

  useEffect(() => {
    set.availability();
  }, []);

  return (
    <div className="pt-4 pb-12">
      {!pharmacyInfo && (
        <p className="text-sm text-center text-neutral-400">Загрузка...</p>
      )}

      {pharmacyInfo && (
        <PharmacyCard
          name={pharmacyInfo.pharmacy.name}
          address={pharmacyInfo.pharmacy.address}
          variant={
            pharmacyInfo.pharmacy.id === checkout.pharmacyId
              ? undefined
              : 'select'
          }
          onPress={() => {
            setCheckout((s) => ({
              ...s,
              pharmacyId: pharmacyInfo.pharmacy.id,
            }));
            navigate(-1);
          }}
          statuses={[
            { variant: 'open', children: 'Открыто с 10:00 до 00:00' },
            { variant: 'available' },
          ]}
        >
          <div className="flex flex-col gap-y-6 py-6">
            <div className="flex flex-col gap-y-4">
              <p className="text-[#222223] font-semibold text-base">
                Доступные товары
              </p>

              <div className="flex flex-row items-center gap-x-3 overflow-hidden">
                {cart.map((item) => (
                  <div key={item.id} className="w-16 h-16 flex-shrink-0">
                    <LazyImage
                      src={item.main_photo || '/product_placeholder.jpg'}
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-col gap-y-4 hidden">
              <p className="text-[#222223] font-semibold text-base">
                Недоступные товары
              </p>

              <div className="flex flex-row items-center gap-x-3 overflow-y-scroll">
                {cart.map((item) => (
                  <div key={item.id} className="w-16 h-16 flex-shrink-0">
                    <LazyImage
                      src={item.main_photo || '/product_placeholder.jpg'}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </PharmacyCard>
      )}
    </div>
  );
};
